import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getClientDocuments = async (clientId) => {
  return await request.get(
    `/HousingStock/client/documents/${clientId}`,
    {},
    'При загрузке документов произошла ошибка',
    []
  );
};

const useClientDocuments = (clientId, options = {}) => {
  return useQuery(
    getQueryKeys.clientDocuments(clientId),
    () => getClientDocuments(clientId),
    options
  );
};

export default useClientDocuments;
